import { List, ListItem, Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface GeneralDialogProps extends HelpDialogLayoutProps {}
export default function GeneralDialog(props: GeneralDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <BodyTypographies
          contents={[
            "あなたの睡眠の質に影響を与えた生活習慣は特定されませんでしたが、いろいろな生活習慣が睡眠へ影響しています。",
          ]}
        />
        <SectionStack>
          <Typography variant="subtitle2">環境</Typography>
          <BodyTypographies
            contents={[
              "光・音・温度・湿度など就寝環境も睡眠に影響を与えます。",
              "明るさや音が気になる場合は、カーテンを防音や遮光機能のあるものに取り換えるとよいでしょう。温度・湿度は朝まで適温を保つようにしましょう。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">喫煙</Typography>
          <BodyTypographies
            contents={[
              "ニコチンには強い覚醒作用があり、寝付きが悪くなる・中途覚醒の増加・睡眠効率の低下・深睡眠の減少などさまざまな影響をもたらします。喫煙歴の長い人は睡眠時無呼吸症候群のリスクが高くなります。",
              "喫煙により摂取したニコチンは約1時間作用します。少なくとも就寝1時間前や途中で起きた時の喫煙は避けましょう。",
            ]}
          />
        </SectionStack>
        <BodyTypographies
          contents={[
            "これら以外にもいろいろな生活習慣が影響していますが、眠りにつく前にリラックスする方法として、簡単にできる腹式呼吸法をご紹介します。",
          ]}
        />
        <SectionStack>
          <Typography variant="subtitle2">腹式呼吸法のポイント</Typography>
          <BodyTypographies
            contents={[
              "ストレスや緊張状態では呼吸が浅く速くなりますが、リラックス状態では深くゆったりとした呼吸になります。このように、体の状態と呼吸には密接な関係があり、意識的に呼吸を整えることでリラックス効果を高めることが可能です。特に腹式呼吸は、副交感神経を活性化させ、心身を落ち着かせる効果があります。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">腹式呼吸の手順</Typography>
          <List
            sx={{
              ...{
                listStyleType: "decimal",
                ml: 2,
                pl: 4,
                py: 0,
                "& .MuiListItem-root": {
                  display: "list-item",
                  lineHeight: "21px",
                  pl: 1,
                  py: 0,
                  "&::marker": {
                    color: "#3d3d3d",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                },
              },
            }}
          >
            <ListItem>
              <BodyTypographies
                contents={[
                  "姿勢を整える",
                  "腹式呼吸は、座った状態や横になった状態で行えます。おへその下に手を置き、体の力を抜きましょう。",
                ]}
              />
            </ListItem>

            <ListItem>
              <BodyTypographies
                contents={[
                  "息を吐く",
                  "口からゆっくりと息を吐き、下腹部をへこませます。この際、体の緊張が息とともに出ていくようにイメージしてください。",
                ]}
              />
            </ListItem>

            <ListItem>
              <BodyTypographies
                contents={[
                  "息を吸う",
                  "苦しくならない程度まで息を吐いたら、鼻から自然に息を吸い、下腹部を膨らませます。",
                ]}
              />
            </ListItem>

            <ListItem>
              <BodyTypographies
                contents={[
                  "呼吸に集中する",
                  "吐く息に気持ちを向け、心を落ち着けることを意識します。リラックス効果を高めるため、ゆっくりとしたペースで呼吸を続けましょう。",
                ]}
              />
            </ListItem>
          </List>
        </SectionStack>
        <BodyTypographies
          contents={[
            "実施時間",
            "1回あたり5～10分を目安に行い、体が緊張から解放される感覚を味わってください。",
          ]}
        />
      </ContentStack>
    </HelpDialogLayout>
  );
}
